import {withFormik} from "formik";
import * as yup from "yup"
import httpClient from "../../../services/httpClient";
import {videoProductApi} from "../../../constans/apiUrls";
import {IVideoProductSpecialAttributeData} from "../../../contracts/data/video_product";
import InnerAddSpecialAttributeToVideoProductForm
    from "../../../components/FormTemplates/video_product/InnerAddSpecialAttributeToVideoProductForm";


const addSpecialAttributeToVideoProductFormValidationSchema = yup.object().shape({
    content: yup.string().required("مقدار ویژگی الزامی میباشد"),
})

interface IAddSpecialAttributeToVideoProductFormProps {
    formType?: string,
    videoProductId: number,
    prevData: IVideoProductSpecialAttributeData | null,
    handleChange: (data: IVideoProductSpecialAttributeData) => void
}

const AddSpecialAttributeToVideoProductForm = withFormik<IAddSpecialAttributeToVideoProductFormProps, IVideoProductSpecialAttributeData>({
    mapPropsToValues: props => ({
        id: props?.prevData !== null ? props?.prevData?.id : 0,
        video_product: props?.prevData !== null ? props?.prevData?.video_product : props?.videoProductId,
        content: props?.prevData !== null ? props?.prevData?.content : '',
        is_active: props?.prevData !== null ? props?.prevData?.is_active : false,
    }),
    mapPropsToStatus: props => ({
        formType: props.formType,
    }),
    validationSchema: addSpecialAttributeToVideoProductFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        if(formikBag?.props?.formType === 'create'){
            await httpClient().post(videoProductApi.special_attributes_create, values)
                .then(response => {
                    if(response.status === 201 ){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                        formikBag.props.handleChange(response?.data?.data)
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error?.response.data
                }))
        }else{
            await httpClient().put(`${videoProductApi.special_attributes_update}/${values.id}`, values)
                .then(response => {
                    if(response.status === 200 ){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                        formikBag.props.handleChange(response?.data?.data)
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error?.response.data
                }))
        }
    },
    displayName: 'AddSpecialAttributeToVideoProductForm'
})(InnerAddSpecialAttributeToVideoProductForm)

export default AddSpecialAttributeToVideoProductForm